<template>
  <div :class="$style.languageParent">
    <IconLanguage />
    <LanguageSelector
      v-for="lang in languages"
      :key="lang.abbr"
      :abbr="lang.abbr"
      :state="lang.abbr === activeLang ? 'active' : 'inactive'"
      :hover="lang.abbr === hoveredLang.abbr && hoveredLang.hover ? 'hover' : 'inactive'"
      className="design-component-instance-node"
      @activate="setActiveLang"
      @handleMouseOver="setMouseOver"
      @handleMouseOut="setMouseOut"
    />
  </div>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue'
import LanguageSelector from './LanguageSelector.vue'
import IconLanguage from './icons/iconLanguage.vue'
import { useLanguageStore } from '@/stores/language'

export default defineComponent({
  name: 'LanguageSelectorContainer',
  components: {
    LanguageSelector,
    IconLanguage
  },
  setup() {
    const languageStore = useLanguageStore()
    const activeLang = ref(languageStore.language)
    const hoveredLang = ref({
      abbr: '',
      hover: false
    })

    const languages = [{ abbr: 'Fi' }, { abbr: 'En' }, { abbr: 'Pl' }] /*, { abbr: 'Ru' } */
    const setActiveLang = (abbr: string) => {
      languageStore.setLanguage(abbr)
    }
    const setMouseOver = (abbr: string) => {
      hoveredLang.value.abbr = abbr
      hoveredLang.value.hover = true
    }
    const setMouseOut = (abbr: string) => {
      hoveredLang.value.abbr = abbr
      hoveredLang.value.hover = false
    }
    languageStore.$subscribe((mutation, state) => {
      activeLang.value = state.language
    })
    return {
      currentLanguage: languageStore.language,
      activeLang,
      languages,
      hoveredLang,
      setActiveLang,
      setMouseOver,
      setMouseOut
    }
  }
})
</script>
<style module>
.languageParent {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  font-size: 16px;
}
</style>
